import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import OrganisationGroupsDashboard from "../pages/Dashboard";
import OrganisationGroupsMembers from "../pages/Members";
import OrganisationGroupsStaff from "../pages/Staff";
import OrganisationGroupsMemberOrganisations from "../pages/MemberOrganisations";
import OrganisationGroupsTeacherDetail from "../pages/TeacherDetail";
import OrganisationGroupsSettings from "../pages/Settings";
import OrganisationGroupsSchoolDetails from "../pages/SchoolDetails";
import OrganisationGroupsHelpAndSupport from "../pages/HelpAndSupport";
import OrganisationGroupsReportAnIssue from "../pages/ReportAnIssue";
import OrganisationGroupsUpdatePassword from "../pages/UpdatePassword";
import OrganisationPrivateRoutesSuspense from "../layout/OrganisationPrivateRoutesSuspense";
import {
  getAuthenticatedHomeRoute,
  isOrganisationGroupUser,
} from "../../Util/authRedirect";
import { getOrganisationRoleAccess } from "../utils/roleAccess";

export default function OrganisationRoutes() {
  const userData = useSelector((state) => state?.authSlice.userData?.payload);
  const access = getOrganisationRoleAccess(userData);

  if (!isOrganisationGroupUser(userData)) {
    return <Navigate to={getAuthenticatedHomeRoute(userData)} replace />;
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to="dashboard" replace />} />
      <Route
        path="dashboard"
        element={
          <OrganisationPrivateRoutesSuspense>
            <OrganisationGroupsDashboard />
          </OrganisationPrivateRoutesSuspense>
        }
      />
      <Route
        path="staff"
        element={
          access.canViewStaff ? (
            <OrganisationPrivateRoutesSuspense>
              <OrganisationGroupsStaff />
            </OrganisationPrivateRoutesSuspense>
          ) : (
            <Navigate to="/organisations/dashboard" replace />
          )
        }
      />
      <Route
        path="members"
        element={
          access.canViewMemberOrganisations ? (
            <OrganisationPrivateRoutesSuspense>
              <OrganisationGroupsMembers />
            </OrganisationPrivateRoutesSuspense>
          ) : (
            <Navigate to="/organisations/dashboard" replace />
          )
        }
      />
      <Route
        path="member-organisations"
        element={
          access.canViewMemberOrganisations ? (
            <OrganisationPrivateRoutesSuspense>
              <OrganisationGroupsMemberOrganisations />
            </OrganisationPrivateRoutesSuspense>
          ) : (
            <Navigate to="/organisations/dashboard" replace />
          )
        }
      />
      <Route
        path="teacher-detail/:id"
        element={
          <OrganisationPrivateRoutesSuspense>
            <OrganisationGroupsTeacherDetail />
          </OrganisationPrivateRoutesSuspense>
        }
      />
      <Route
        path="settings"
        element={
          <OrganisationPrivateRoutesSuspense>
            <OrganisationGroupsSettings />
          </OrganisationPrivateRoutesSuspense>
        }
      />
      <Route
        path="update-password"
        element={
          <OrganisationPrivateRoutesSuspense>
            <OrganisationGroupsUpdatePassword />
          </OrganisationPrivateRoutesSuspense>
        }
      />
      <Route
        path="help-support"
        element={
          <OrganisationPrivateRoutesSuspense>
            <OrganisationGroupsHelpAndSupport />
          </OrganisationPrivateRoutesSuspense>
        }
      />
      <Route
        path="report-issue"
        element={
          <OrganisationPrivateRoutesSuspense>
            <OrganisationGroupsReportAnIssue />
          </OrganisationPrivateRoutesSuspense>
        }
      />
      <Route
        path="school-details"
        element={
          access.canViewSchoolDetails ? (
            <OrganisationPrivateRoutesSuspense>
              <OrganisationGroupsSchoolDetails />
            </OrganisationPrivateRoutesSuspense>
          ) : (
            <Navigate to="/organisations/settings" replace />
          )
        }
      />
    </Routes>
  );
}
